import { Component, OnInit, Inject } from "@angular/core";
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { locale as english } from './i18n/en';
import { locale as dutch } from './i18n/nl';
import { AppConfig } from '../../core/configs/app-config';
import { HttpClient,  } from '@angular/common/http';
import { MatDialog} from '@angular/material/dialog';
import { Router } from '@angular/router';
import {MedewerkerPlanning} from '../../model/dto/medewerkers/overzicht';
import {PlanningOverzicht} from '../../model/dto/planning/overzicht';
import {formatDate} from '@angular/common';
import 'fullcalendar';
import 'fullcalendar-scheduler';
import * as jQuery from "jquery";
import {UserService } from "../../core/services/user.service";
import { PlanningKlantGegevensDialog } from './planningKlantGegevens/planningKlantGegevensDialog';

(window as any).$ = (window as any).jQuery = jQuery;
declare let $: any;
@Component({
    selector   : 'planningoverzichtsimpel',
    templateUrl: './planningoverzichtsimpel.component.html',
    styleUrls  : ['./planningoverzichtsimpel.component.scss']
})



export class PlanningOverzichtSimpelComponent implements OnInit
{
  Medewerkers: MedewerkerPlanning[] = [];
  PlanningOverzicht: PlanningOverzicht[] = [];
  selectedAfdelingen: any[] = [];
  cbChecked : boolean;
  config: any;
  aantaldagen : number = 7;
    constructor(private router: Router, public dialog: MatDialog, private _fuseTranslationLoaderService: FuseTranslationLoaderService, private userService:UserService, @Inject(HttpClient) private http?: HttpClient)
    {
        this.config = {
            "SERVERPROTOCOL": AppConfig.ApiProtocol,
            "SERVERURL": AppConfig.ApiLoginHost,
            "SERVERPORT": AppConfig.ApiPort,
            "APPLICATIONID": AppConfig.ApiApplicationId,
            "METHOD": AppConfig.ApiMethod,
            "LOGINURL": AppConfig.ApiLoginUrl,
            "STACKURL": AppConfig.ApiUrl
          };
        this._fuseTranslationLoaderService.loadTranslations(english, dutch);

    }

    datetot: Date;
    datebegin: Date;
    loading: boolean = false;

    updateMedewerkers(){

     var body = {
      "AfdIDs": this.selectedAfdelingen,
      "InplanbareMedewerker": true
     };


    let conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/planning/medewerkersoverzicht";

    var post = this.http.post(conString, body);
    post.subscribe(     
    (results: any) => {
      this.Medewerkers.length = 0;
    for (var result of  results){ 
      if (result["MedewerkerID"] == this.userService.getCurrentUser().MedewerkerID) {
        this.Medewerkers.push({ id:result["MedewerkerID"], title:result["CplNaam"], afdeling:"services"});
      }
    }  

    $('#calendar').fullCalendar("refetchResources");
    },
    (error) => {
    console.error(error);
    });
    
    }



  ngOnInit() {
    this.reloadSheduler();
  }

  onMin1Week(){
    if (this.loading == true){
      return;
    }
    this.loading = true;
    console.log(this.datebegin);
    this.datebegin.setDate(this.datebegin.getDate() - 7);
    console.log(this.datebegin);
   // (document.getElementById('mat-input-0') as HTMLInputElement).value = formatDate(this.datebegin, 'dd/MM/yyyy', 'en');
    console.log(this.datebegin);
    this.UpdateCalendar();
  }

  onMin1Day(){
    if (this.loading == true){
      return;
    }
    this.loading = true;
    this.datebegin.setDate(this.datebegin.getDate() - 1);
    //(document.getElementById('mat-input-0') as HTMLInputElement).value = formatDate(this.datebegin, 'dd/MM/yyyy', 'en');
    this.UpdateCalendar();
  }
  
  onPlus1Day(){
    if (this.loading == true){
      return;
    }
    this.loading = true;
    this.datebegin.setDate(this.datebegin.getDate() + 1);
    //(document.getElementById('mat-input-0') as HTMLInputElement).value = formatDate(this.datebegin, 'dd/MM/yyyy', 'en');
    this.UpdateCalendar();
  }

  onPlus1Week(){
    if (this.loading == true){
      return;
    }
    this.loading = true;
    this.datebegin.setDate(this.datebegin.getDate() + 7);
    this.UpdateCalendar();
  
   

  }

  onToday(){
    if (this.loading == true){
      return;
    }
    this.loading = true;
    this.datebegin = new Date();
    this.datebegin.setDate( this.datebegin.getDate());
    this.UpdateCalendar();
    
  }

  changeDate(date){
    this.datebegin = date.value;
    this.UpdateCalendar();
  }

  UpdateCalendar(){
    this.PlanningOverzicht = [];
    //(document.getElementById('mat-input-0') as HTMLInputElement).value = formatDate(this.datebegin, 'dd/MM/yyyy', 'en');
    $('#calendar').fullCalendar("gotoDate", this.datebegin );
    this.datetot = new Date(this.datebegin);
    console.log(this.datebegin.getDate());
    this.datetot.setDate(this.datebegin.getDate() + this.aantaldagen);

    let conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/planning/overzicht/" + formatDate(this.datebegin, 'dd-MM-yyyy', 'en') + "/"+ formatDate(this.datetot, 'dd-MM-yyyy', 'en') + "/" + this.userService.getCurrentUser().MedewerkerID;
   console.log(conString);
    var get = this.http.get(conString);
    get.subscribe(     
    (results:any) => {
    for (var result of  results){ 
      if (result["MedewerkerID"] != this.userService.getCurrentUser().MedewerkerID) {
        continue;
      }
      var title = "";
      if (result["BedrijfAfkorting"] == "Nr0") {
        title = result["Categorie"] + " " + result["Onderwerp"];         
      } else {
        title = result["BedrijfAfkorting"] + " " + result["Onderwerp"];
      }
      this.PlanningOverzicht.push({ id:result["PlanningID"], resourceId:result["MedewerkerID"], start:result["Start"],end:result["Tot"],title:title, patroon:result["Patroon"], onderwerpID:result["onderwerpID"]});
      }  
      $('#calendar').fullCalendar('removeEvents');
      $('#calendar').fullCalendar('addEventSource', this.PlanningOverzicht);
      this.loading = false;
    } )
    
  }


  reloadSheduler(){
    $('#calendar').fullCalendar('destroy');
    this.Medewerkers = [];
    this.PlanningOverzicht = [];

    this.cbChecked = true;

    var body = {
      "AfdIDs": this.selectedAfdelingen,
      "InplanbareMedewerker": true
     };

    this.updateMedewerkers();

    this.datetot = new Date();
    this.datetot.setDate( this.datetot.getDate() + this.aantaldagen );
    this.datebegin = new Date();
    this.datebegin.setDate( this.datebegin.getDate());

 

   let conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/planning/overzicht/" + formatDate(this.datebegin, 'dd-MM-yyyy', 'en') + "/"+ formatDate(this.datetot, 'dd-MM-yyyy', 'en') + "/" + this.userService.getCurrentUser().MedewerkerID;

    var get = this.http.get(conString);
    get.subscribe(     
    (results:any) => {
    for (var result of  results){ 

      if (result["MedewerkerID"] != this.userService.getCurrentUser().MedewerkerID) {
        continue;
      }

      var title = "";
      if (result["BedrijfAfkorting"] == "Nr0") {
        title = result["Categorie"] + " " + result["Onderwerp"];      
      } else {
        title = result["BedrijfAfkorting"] + " " + result["Onderwerp"];
      }
      this.PlanningOverzicht.push({ id:result["PlanningID"], resourceId:result["MedewerkerID"], start:result["Start"],end:result["Tot"],title:title, patroon:result["Patroon"], onderwerpID:result["onderwerpID"]});
    }  

    $('#calendar').fullCalendar({
      aspectRatio: 1,
      scrollTime: '00:00', // undo default 6am scrollTime
      header: {
        left: '',
        center: 'title',
        right: '' 
          //...other buttons
     },
     height: 400,
     weekNumbers: true,
     weekNumberCalculation: "ISO",
      defaultView: 'timelineThreeDays',
      views: {
        timelineThreeDays: {
          type: 'timeline',
          duration: { days: this.aantaldagen }
        }
      },
      eventRender : function(event, element) {
        element[0].title = event.title;
     },eventClick: (calEvent, jsEvent, view) => {
  
       const dialogRef = this.dialog.open(PlanningKlantGegevensDialog, {
         maxHeight: '100vh',
         disableClose: true,
         data: {calEvent: calEvent, onlyToday: true}
       });
       dialogRef.afterClosed().subscribe(result => {
         this.UpdateCalendar();
       });
      
       $(this).css('border-color', 'red');
  
      },
      events:this.PlanningOverzicht,
      schedulerLicenseKey: 'GPL-My-Project-Is-Open-Source',
      slotDuration: '24:00'
    });
    
    },
    (error) => {
    console.error(error);
    });
    
  }




}
